export class ProductType{
    public contractTypes = [
        {
            group: 'Azure',
            items: [
                { code: 101, name: 'CSP'},
                { code: 102, name: 'SCE' }
            ]
        },
        {
            group: 'Office',
            items: [
                { code: 201, name: 'CSP'},
                { code: 202, name: 'EA'},
                { code: 203, name: 'MPSA' },
                { code: 204, name: 'SPLA' }
            ]
        },
        {
            group: 'GRUPO NAÇÃO DIGITAL',
            items: [
                { code: 301, name: 'GRUPO NAÇÃO DIGITAL'}
            ]
        },
        {
            group: 'PROJETOS',
            items: [
                { code: 401, name: 'PROJETOS'},
            ]
        },
        {
            group: 'MANAGE SERVICES',
            items: [
                { code: 501, name: 'MANAGE SERVICES' },
            ]
        },
        {
            group: 'CLOUD',
            items: [
                { code: 601, name: 'INCENTIVOS' },
                { code: 602, name: 'REEMBOLSOS' }
            ]
        },
        {
            group: 'LICENÇAS GOOGLE',
            items: [
                { code: 701, name: 'LICENÇAS GOOGLE' }
            ]
        }
    ]

    public getFullNameByCode(code: number) {
        for (const contractTypes of this.contractTypes) {
            const index = contractTypes.items.findIndex((item) => item.code === code);
            if (index !== -1) {
                return `${contractTypes.group} - ${contractTypes.items[index].name}`;
            }
        }
        return '-';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/billing-letter/productType.ts